import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJob, deleteJob, editJob, getJobs } from "./jobsApi";

// initialState...
const initialState = {
  jobs: [],
  isLoading: false,
  isError: false,
  error: "",
};

// thunks
// fetch jobs thunk...
export const fetchJobs = createAsyncThunk("jobs/fetchJobs", async () => {
  const response = await getJobs();
  return response;
});

// createJob thunk...
export const createJob = createAsyncThunk("jobs/createJob", async (data) => {
  const response = await addJob(data);
  return response;
});

// update job thunk...
export const updateTheJob = createAsyncThunk(
  "jobs/updateTheJob",
  async ({ id, data }) => {
    const response = await editJob(id, data);
    return response;
  }
);

// delete job thunk...
export const deleteTheJob = createAsyncThunk(
  "jobs/deleteTheJob",
  async (id) => {
    const response = await deleteJob(id);
    return response;
  }
);

// thunks end...

// slice
const jobsSlice = createSlice({
  name: "jobsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetchjobs ...
    builder.addCase(fetchJobs.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
      state.error = "";
    });
    builder.addCase(fetchJobs.fulfilled, (state, action) => {
      state.isLoading = false;
      state.jobs = action.payload;
    });
    builder.addCase(fetchJobs.rejected, (state, action) => {
      state.isError = true;
      state.error = action.error?.message;
      state.jobs = [];
      state.isLoading = false;
    });

    // createJob..
    builder.addCase(createJob.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
      state.error = "";
    });
    builder.addCase(createJob.fulfilled, (state, action) => {
      state.isLoading = false;
      state.jobs.push(action.payload);
    });
    builder.addCase(createJob.rejected, (state, action) => {
      state.isError = true;
      state.error = action.error?.message;
      state.isLoading = false;
    });

    // updateTheJob...
    builder.addCase(updateTheJob.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
      state.error = "";
    });
    builder.addCase(updateTheJob.fulfilled, (state, action) => {
      state.isLoading = false;
      const { id } = action.payload || {};
      let indexToUpdate = state.jobs.findIndex((job) => job?.id === id);
      state.jobs[indexToUpdate] = action.payload;
    });
    builder.addCase(updateTheJob.rejected, (state, action) => {
      state.isError = true;
      state.error = action.error?.message;
      state.isLoading = false;
    });

    // deleteTheJob...
    builder.addCase(deleteTheJob.pending, (state) => {
      // state.isLoading = true;
      state.isError = false;
      state.error = "";
    });
    builder.addCase(deleteTheJob.fulfilled, (state, action) => {
      // state.isLoading = false;
      state.jobs = state.jobs.filter((job) => job?.id !== action?.meta?.arg);
    });
    builder.addCase(deleteTheJob.rejected, (state, action) => {
      state.isError = true;
      state.error = action.error?.message;
      // state.isLoading = false;
    });
  },
});

export default jobsSlice.reducer;
export const { editActive, editInactive } = jobsSlice.actions;
